import type {ImmersivePlugin, NavigationItem} from '@github-ui/copilot-chat/plugin'
import type {CopilotChatState} from '@github-ui/copilot-chat/utils/copilot-chat-reducer'
import {copilotLocalStorage} from '@github-ui/copilot-chat/utils/copilot-local-storage'
import type {useNavigate} from '@github-ui/use-navigate'
import {SparkleIcon} from '@primer/octicons-react'
import {Label} from '@primer/react'
import {createElement} from 'react'

import {SPARK_PATH, SPARK_PLUGIN_ID, SPARK_PLUGIN_NAME} from './utils/constants'

export class SparkPlugin implements ImmersivePlugin {
  id = SPARK_PLUGIN_ID

  displayName = SPARK_PLUGIN_NAME

  constructor(sparkEnabled: boolean = false) {
    this.sparkEnabled = sparkEnabled
  }

  sparkEnabled: boolean

  navigationItems: NavigationItem[] = [
    {
      id: SPARK_PLUGIN_ID,
      displayName: 'Spark',
      href: SPARK_PATH,
      icon: SparkleIcon,
      // eslint-disable-next-line @github-ui/github-monorepo/no-react-create-element -- Convert to JSX Syntax. This Requires changing to a TSX file
      label: createElement(Label, {variant: 'success'}, 'Preview'),
      external: true,
    },
  ]

  slashCommand = {
    key: 'spark',
    name: 'Spark',
    description: 'Transform ideas into full-stack intelligent apps',
    icon: SparkleIcon,
    enabled: () => this.sparkEnabled,
    disabledAction: (navigate: ReturnType<typeof useNavigate>) => {
      navigate(SPARK_PATH)
    },
    execute: (params: string, _chatState: CopilotChatState, navigate: ReturnType<typeof useNavigate>) => {
      copilotLocalStorage.setSparkEntrypointMessage(params)
      navigate(SPARK_PATH)
      return true
    },
    suggestions: [
      'Make a web app to upload and analyze log files, showing error frequencies and trends.',
      'Create an app to track team PTO and on-call schedules and visualize available team capacity by week.',
      'Create a dashboard that visualizes uploaded CSV data as interactive charts and summary stats.',
    ],
  }
}
